import RestApiModel from "@/api/Model/RestApiModel";

class CoverholderDocumentType extends RestApiModel {
  static getResourceEndpoint() {
    return '/CoverholderDocumentTypes';
  }
}

export default CoverholderDocumentType;
